// MR-IN — the Magic Room's own short warm guide, in Lala's voice. Not machinery, not em dashes.
//
// R86 took it out of App.tsx on R85's precedent: it renders `ModalBackdrop`, which was the reason
// `LegalModal` sat in the monolith until R81 moved that component out and R85 went back for the
// note. Hookless, so `scripts/r86-owner-reads.mjs` CALLS it — which is what a room's own account of
// itself always needed, because every word in here is copy nothing was checking.
import { ModalBackdrop } from "./ModalBackdrop";

export function MagicRoomInstructions({ onClose }: { onClose: () => void }) {
  return (
    <ModalBackdrop label="How the Magic Room works">
      <div className="membership-modal mr-instructions">
        <button className="modal-close" type="button" onClick={onClose} aria-label="Close">x</button>
        <p className="eyebrow">The Magic Room</p>
        <h2>How this room works</h2>
        <div className="mr-instructions__body">
          <p>Every book here gives you something you can work. The Greater Keys of Solomon gives you a pentacle for your situation. The Books of Moses gives you a seal. The Book of Roots gives you the herbs for your aim. Spell Your Oils makes you a conjure oil. The Spellbook writes you a spell. Petition writes you a petition paper.</p>
          <p>The Cauldron is where it comes together. Send any of these to the Cauldron, then compile, and I draw them into one working, or into separate workings when they are truly for different aims, each laid out step by step in my way.</p>
          <p>The Notepaper is for your own words. Write your own petition, incantation, or chant, send it to the Cauldron, and it rides into your working exactly as you wrote it. You can send a seal you made in the Seal Creator too, right from your shelf.</p>
          <p>Everything you make lands on this room's shelf, so it is always there when you come back for it.</p>
        </div>
      </div>
    </ModalBackdrop>
  );
}
